var LAZY_IDENTIFIER = 'lazy-load';

var LazyLoader = {
    observer: null,

    /**
     * @param {*} items
     */
    init: function (items) {
        var self = this;

        if (this.supportsObservers()) {
            this.observer = new IntersectionObserver(
                function (entries) {
                    self.evaluateEntries(entries);
                },
                {
                    rootMargin: '100px',
                    threshold: 0.1,
                }
            );
        }

        this.observeItems(items);
    },

    /**
     * @param {*} entries
     */
    evaluateEntries: function (entries) {
        var self = this;

        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];

            if (!entry.isIntersecting) {
                return;
            }

            var target = entry.target;

            self.loadItem(target);
            self.observer.unobserve(target);
        }
    },

    /**
     * @param {*} items
     */
    observeItems: function (items) {
        var self = this;

        $(items).each(function () {
            self.observeItemOrLoad(this);
        });
    },

    /**
     * @param {*} item
     */
    observeItemOrLoad: function (item) {
        if (this.supportsObservers()) {
            this.observer.observe(item);
        } else {
            this.loadItem(item);
        }
    },

    /**
     * Call loadPicture, loadImg, loadSource, etc.
     * @param {*} item
     */
    loadItem: function (item) {
        var type = item.localName;

        this['load' + type.charAt(0).toUpperCase() + type.slice(1)](item);

        if (item.classList.contains(LAZY_IDENTIFIER)) {
            item.classList.remove(LAZY_IDENTIFIER);
        }
    },

    /**
     * @param {*} element
     */
    loadPicture: function (element) {
        for (var i = 0; i < element.children.length; i++) {
            this.loadItem(element.children[i]);
        }
    },

    /**
     * @param {*} element
     */
    loadSource: function (element) {
        element.setAttribute('srcset', element.dataset.lazySrc);
    },

    /**
     * @param {*} element
     */
    loadImg: function (element) {
        element.setAttribute('src', element.dataset.lazySrc);
    },

    /**
     * @returns boolean
     */
    supportsObservers: function () {
        return 'IntersectionObserver' in window && 'MutationObserver' in window;
    },
};

// Init and observe items that are ready.
LazyLoader.init(document.getElementsByClassName(LAZY_IDENTIFIER));

$('body').on('carousel:setup', function () {
    // Einstein reccommednations are done loading, observe any lazy items.
    LazyLoader.observeItems(document.getElementsByClassName(LAZY_IDENTIFIER));
});

var recommendationObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type !== 'childList' || !mutation.addedNodes.length) {
            return;
        }

        LazyLoader.observeItems(
            document.getElementsByClassName(LAZY_IDENTIFIER)
        );
    }
});

var recommendationSlots = $('[id^=cq_recomm_slot-]');

for (var i = 0; i < recommendationSlots.length; i++) {
    recommendationObserver.observe(recommendationSlots[i], { childList: true });
}

$('body').on('search:refined', function () {
    LazyLoader.init(document.getElementsByClassName(LAZY_IDENTIFIER));
});
